import get from './requests/get';
import Lambda from '../common/lambda';

export default new Lambda(get);
